/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useDebounce } from '@utilities/hooks'

export const useFetch = (client, dispatchAction) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const dispatch = useDispatch()

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await client()
        if (response.data && dispatchAction) dispatch(dispatchAction(response.data))
        setData(response.data)
        setLoading(false)
        console.log(response)
      } catch (e) {
        setError(e.message)
        setLoading(false)
        setData(null)
        console.error(e.message)
      }
    }
    getData()
  }, [])

  return { data, loading, error }
}

//hook que implementa useFetch, useSearch y usePaginate
export const useRequestOld = (client, filters) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState(null)
  const [pagination, setPagination] = useState({ currentPage: 1, lastPage: 1 })

  const debouncedSearch = useDebounce(search, 1000)

  const fetch = async (page) => {
    setLoading(true)
    try {
      const { data, meta } = await client({ search, per_page: 25, page, ...filters })
      setData(data)
      setPagination({ currentPage: meta.current_page, lastPage: meta.last_page })
    } catch (e) {
      console.error(e.message)
    }
    setLoading(false)
  }
  //did mount
  useEffect(() => fetch(), [])
  //search with debounce
  useEffect(() => debouncedSearch !== null && fetch(), [debouncedSearch])
  return { data, loading, search, setSearch, pagination, fetch }
}

export const useRequest = (client, filters) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState(null)
  const [pagination, setPagination] = useState({ currentPage: 1, lastPage: 1 })

  const debouncedSearch = useDebounce(search, 1000)

  const fetch = async (page) => {
    setLoading(true)
    try {
      const { data, meta } = await client({ search, limit: 25, page, ...filters })
      const lastPage = Math.ceil(meta.total / meta.size)
      setData(data)
      setPagination({ currentPage: meta.page, lastPage: lastPage })
    } catch (e) {
      console.error(e.message)
    }
    setLoading(false)
  }
  //did mount
  useEffect(() => fetch(), [])
  //search with debounce
  useEffect(() => debouncedSearch !== null && fetch(), [debouncedSearch])
  return { data, loading, search, setSearch, pagination, fetch }
}
